{% block sw_cms_block_acris_blog_title %}
    <div class="sw-cms-preview-acris-blog-title">
        <h1>{{ $t('acris-blog.elements.blogTitle.preview.title') }}</h1>
    </div>
{% endblock %}
